<mat-menu #childMenu="matMenu">
    <div *ngFor="let item of items">
        <div *ngIf="item.menus.length === 0 else menuButton">
            <a *ngIf="item.isSgc1Url else routerLink" [href]="item.path" title='{{ item.name | translate}}' class="mat-mdc-menu-item">{{ item.name | translate }}</a>
            <ng-template #routerLink>
                <a [routerLink]="item.path" title='{{ item.name | translate}}' class="mat-mdc-menu-item nav-main-list__item" routerLinkActive="nav-main-list__item--active">{{ item.name | translate }}</a>
            </ng-template>
        </div>
        <ng-template #menuButton>
            <button mat-menu-item [matMenuTriggerFor]="menu.childMenu" [title]="item.name | translate">{{ item.name | translate}}</button>
            <app-menu-item  #menu [items]="item.menus"></app-menu-item>
        </ng-template>
    </div>
</mat-menu>